import React from "react"
import Artwork from "../../components/Artwork"
import { useControl } from "react-three-gui"

function Artworks() {
  //   const color = useControl("colour", {
  //     type: "color",
  //     value: "#fff",
  //   })
  //   const emissive = useControl("emissive", {
  //     type: "color",
  //     value: "#737373",
  //   })

  const h = 1.32

  // const x = useControl("rotation", {
  //   type: "number",
  //   value: -0.63,
  //   min: -Math.PI * 2,
  //   max: Math.PI * 2,
  // })

  // const h2 = useControl("height", {
  //   type: "number",
  //   value: h,
  //   min: -0.5,
  //   max: 3,
  // })
  // const scale = useControl("scale", {
  //   type: "number",
  //   value: 1,
  //   min: 1,
  //   max: 5,
  // })

  // const pos = useControl("ball position", {
  //   type: "xypad",
  //   distance: 7,
  //   scrub: true,
  // })

  return (
    <>
      <Artwork // first
        src="Artworks/nik1.jpg"
        position={[-13.7, h, 11.6]}
        rotation={[0, 2.35, 0]}
        // rotation={[0, x, 0]}
        // scale={[scale,scale,scale]}
      />
      <Artwork
        src="Artworks/nik2.jpg"
        position={[-14.1, h, -11.1]}
        rotation={[0, 0.78, 0]}
      />
      <Artwork
        src="Artworks/nik3.jpg"
        position={[9.2, h, -11.1]}
        rotation={[0, -0.8, 0]}
        // rotation={[0, x, 0]}
        // position={[pos.x, h2, pos.y]}
      />
      <Artwork
        src="Artworks/nik4.jpg"
        position={[9.6, h, 11.6]}
        rotation={[0, -2.35, 0]}
        // position={[pos.x, h2, pos.y]}
        // scale={[scale,scale,scale]}
      />
    </>
  )
}

export default Artworks
